import BaseModel from './Base.model';
import ProductChassisModel from './ProductChassis.model';

/**
 * Model đại diện cho một xe
 */
export default class DemoCarModel extends BaseModel {
  /**
   * Tạo một instance mới của DemoCar
   * @param {Object} data - Dữ liệu xe demo
   * @param {string} data.id - ID của xe demo
   * @param {string} data.storeId - ID của cửa hàng
   * @param {string} data.productChassisId - ID của số khung số máy
   * @param {ProductChassisModel} data.productChassis - Thông tin số khung và số máy
   * @param {string} data.licensePlate - Biển số xe
   * @param {number} data.status - Trạng thái của xe
   * @param {Date} data.lastMaintenanceDate - Ngày bảo dưỡng lần cuối
   * @param {number} data.currentKm - Km hiện tại
   * @param {string} data.notes - Ghi chú
   * @param {number} data.deleted - Ghi chú
   * @param {Date} data.createdAt - Ngày tạo
   * @param {Date} data.updatedAt - Ngày cập nhật
   * @param {string} data.createdBy - Người tạo
   * @param {string} data.updatedBy - Người cập nhật
   */
  constructor(data = {}) {
    super({
      id: data?.id,
      createdAt: data?.createdAt,
      updatedAt: data?.updatedAt,
    });
    this.productChassisId = data?.productChassisId || '';
    this.storeId = data?.storeId || '';
    this.licensePlate = data?.licensePlate || '';
    this.status = data?.status !== undefined ? data?.status : 0;
    this.lastMaintenanceDate = data?.lastMaintenanceDate || null;
    this.currentKm = data?.currentKm || 0;
    this.notes = data?.notes || '';
    this.createdBy = data?.createdBy || null;
    this.updatedBy = data?.updatedBy || null;
    this.deleted = data?.deleted || 0;

    // CRM outbound sync tracking (ERP -> CRM)
    this.crmSyncStatus =
      data?.crmSyncStatus !== undefined ? data?.crmSyncStatus : null;
    this.crmId = data?.crmId || '';
    this.crmOutboundSyncedAt = data?.crmOutboundSyncedAt || null;
    this.crmOutboundError = data?.crmOutboundError || '';

    // Relations
    this.productChassis = ProductChassisModel.fromJson(data?.productChassis);

    // Additional properties
    this.productName = this?.productChassis?.product.name || '';
    this.productCode = this?.productChassis?.product.code || '';
    this.chassisNumber = this?.productChassis?.chassisNumber || '';
    this.engineNumber = this?.productChassis?.engineNumber || '';
  }

  /**
   * Chuyển đổi từ dữ liệu JSON thành đối tượng DemoCar
   * @param {Object} json - Dữ liệu JSON
   * @returns {DemoCarModel} - Đối tượng DemoCar
   */
  static fromJson(json) {
    return BaseModel.fromJson(json, DemoCarModel);
  }

  /**
   * Chuyển đổi từ danh sách JSON thành danh sách đối tượng DemoCar
   * @param {Array} jsonArray - Mảng dữ liệu JSON
   * @returns {Array<DemoCarModel>} - Mảng đối tượng DemoCar
   */
  static fromJsonArray(jsonArray) {
    return BaseModel.fromJsonArray(jsonArray, DemoCarModel);
  }

  /**
   * Chuyển đổi đối tượng DemoCar thành dữ liệu JSON để gửi lên server
   * @returns {Object} - Dữ liệu JSON
   */
  toJson() {
    return {
      id: this.id,
      storeId: this.storeId,
      productChassisId: this.productChassisId,
      licensePlate: this.licensePlate,
      status: this.status,
      lastMaintenanceDate: this.lastMaintenanceDate,
      currentKm: this.currentKm,
      notes: this.notes,
    };
  }
}
